import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { HttpRequestService } from '../shared/services/http-request.service';
import { NotificationService } from '../shared/services/notification.service';
import { formatUrl } from '../shared/utils/format-url-util';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(
    private httpClient: HttpRequestService,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) {}

  getServiceCodeRates(
    programCode: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.BILLING.GET_BILLING_DROPDOWN_VALUES, {
      programCode,
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
}
